import Mock from 'mockjs'

// 商品列表
const MOCK030001 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'spuInfos|10-20': [{
            'spuId': '@id',
            'spuName': '@cname(2,10)',
            'corpId': '@id',
            'corpName':'@cword(10)',
            'salesVolume|100-1000': 100,
            'price|1000-2000': 1000,
            'attachInfo': {
                'url': '@image("600x600",#b7ef7c)',
                'context': ''
            }
        }],
        'brandInfos|2-10': [{
            'brandId': '@id',
            'brandName': '@cname(2-10)'
        }],
        'attrInfos|2-10': [{
            'attrId': '@id',
            'attrName': '@cname(2,10)',
            'attrValueInfos|10-20': [{
                'attrValueId': '@id',
                'attrValueName': '@cname(2-5)'
            }]
        }],
        'totoalCount|100-500':100
    }
});

export default MOCK030001


// WEBPACK FOOTER //
// ./src/mock/getProductList.js